import React, { memo } from 'react';
import { Switch, Route } from 'react-router-dom';
import { map } from 'lodash';
import Paper from '@material-ui/core/Paper';
import PageNotFound from '../../../shared/components/PageNotFound/PageNotFound';
import RouteWithSubRoutesContainer from '../../../app/containers/RouteWithSubRoutesContainer';
import Denwa from '../../../shared/images/logos/denwa.png';
import GreenLogo from '../../../shared/images/logos/denwa_uc_green.png';
import styles from './login.module.scss';

export default memo(function Login(props) {
    return (
        <div className={styles.container}>
            <Paper className={styles.loginContainer}>
                <div className={styles.productImageContainer}>
                    <div className={styles.textBlock}>
                        <div className={styles.description}>
                            <img alt="DenwaLogo" className={styles.logo} src={Denwa} />
                        </div>
                    </div>
                </div>
                <div className={styles.formContainer}>
                    <img alt="DenwaLogo" height="90" src={GreenLogo} width="125" />
                    <Switch>
                        {map(props.routes, route => <RouteWithSubRoutesContainer key={route.path} {...route} />)}
                        <Route component={PageNotFound} />
                    </Switch>
                </div>
            </Paper>
        </div>
    );
});
